import axios from 'axios'
import router from './../../../router'
import {Errors, Form} from './../../../components/validations/forms.js'

const namespaced = true;

const state = {
  divisions: null,
  branches: null,
  departments: null,
  designations: null,
  companies: null,
  sponsorCompanies: null,
  religions: null,
  nationalities: null,
  groups: null,
  cities: null,
  settingsHR: {
      cutOffDate: null,
      visibilityStart: null,
      visibilityEnd: null,
      cycles: null,
  },
  // timezones: null,
  // timeformats: null,
  // countries: null,
  // languages: null,
  // currencies: null,
  // units: null,
  // settings: null,

};

const getters = {
  getSettingsHR (state) {
    return state.settingsHR
  },
  getDivisions (state) {
    return state.divisions
  },
  getBranches (state) {
    return state.branches
  },
  getDepartments (state) {
    return state.departments
  },
  getDesignations (state) {
    return state.designations
  },
  getCompanies (state) {
    return state.companies
  },
  getSponsorCompanies (state) {
    return state.sponsorCompanies
  },
  getReligions (state) {
    return state.religions
  },
  getNationalities (state) {
    return state.nationalities
  },
  getGroups (state) {
    return state.groups
  },
  getCities (state) {
    return state.cities
  },
};

const mutations = {
  setSettingsHR (state, payload) {
    state.settingsHR = payload
  },
  setDivisions (state, payload) {
    state.divisions = payload
  },
  setBranches (state, payload) {
    state.branches = payload
  },
  setDepartments (state, payload) {
    state.departments = payload
  },
  setDesignations (state, payload) {
    state.designations = payload
  },
  setCompanies (state, payload) {
    state.companies = payload
  },
  setSponsorCompanies (state, payload) {
    state.sponsorCompanies = payload
  },
  setReligions (state, payload) {
    state.religions = payload
  },
  setNationalities (state, payload) {
    state.nationalities = payload
  },
  setGroups (state, payload) {
    state.groups = payload
  },
  setCities (state, payload) {
    state.cities = payload
  },

};


const actions = {
  fetchSettingsHR ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/attendance/setting')
          .then(res => {
            commit('setSettingsHR', res.data.data)
            console.log('fetchSettingsHR - HR Settings Fetched.');
            resolve(res.data.data);})
          .catch(error => {reject(error.response);})
    })
  },


  updateSettingsHR ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.post('/api/attendance/setting', {
          cutOffDate: payload.cutOffDate,
          visibilityStart: payload.visibilityStart,
          visibilityEnd: payload.visibilityEnd,
          cycles: payload.cycles,
      })
          .then(res => {
            console.log('updateSettingsHR - Value Added.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  fetchDivisions ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/division')
        .then(res => {
          commit('setDivisions', res.data.data)
          console.log('fetchDivisions - Divisions Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },

  fetchBranches ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/branch')
        .then(res => {
          commit('setBranches', res.data.data)
          console.log('fetchBranches - fetchBranches Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },

  fetchDepartments ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/department')
        .then(res => {
          commit('setDepartments', res.data.data)
          console.log('fetchDepartments - fetchDepartments Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },

  fetchDesignations ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/designation')
        .then(res => {
          commit('setDesignations', res.data.data)
          console.log('fetchDesignations - fetchDesignations Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },
  fetchCompanies ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/company')
        .then(res => {
          commit('setCompanies', res.data.data)
          console.log('fetchCompanies - fetchCompanies Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },
  fetchSponsorCompanies ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/company')
        .then(res => {
          commit('setSponsorCompanies', res.data.data)
          console.log('fetchSponsorCompanies - fetchSponsorCompanies Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },
  fetchReligions ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/religion')
        .then(res => {
          commit('setReligions', res.data.data)
          console.log('fetchReligions - fetchReligions Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },
  fetchNationalities ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/nationality')
        .then(res => {
          commit('setNationalities', res.data.data)
          console.log('fetchNationalities - fetchNationalities Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },
  fetchGroups ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/group')
        .then(res => {
          commit('setGroups', res.data.data)
          console.log('fetchGroups - fetchGroups Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },
  fetchCities ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/company/user/cities')
        .then(res => {
          commit('setCities', res.data.data)
          console.log('fetchCities - fetchCities Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },


  // TODO: Create Function To Get Company Settings


};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/general/environment.js